(function() {
    'use strict';

    angular
        .module('quantixApp')
        .factory('AdvanceSearchService', AdvanceSearchService);

    AdvanceSearchService.$inject = ['$resource'];

    function AdvanceSearchService ($resource) {
    	
    	var factory = {}; 

    	factory.getIndustryDetails =  $resource(
						'api/advanceSearch/getIndustryDetails',{},
						{
							'industryDetails' : {
								method : 'GET',		
								isArray : true,
								transformResponse : function(data) {
									var myData = [];
									myData.push(data);								
									return myData;											
								}
							}
						});
    	factory.getIndustryDetailsdata =  $resource(
				'api/advanceSearch/getSearchIndustryDetails',{data:'@data'},
				{
					'getSearchData' : {
						method : 'GET',		
						isArray : true,
						transformResponse : function(data) {
							var myData = [];
							myData.push(data);						
							return myData;											
						}
					}
				});
   
        return factory;
    }
})();
